import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import menuData from "./Menu.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleUp,
  faAngleDown,
  faTurnDown,
  faTurnUp,
  faPlus,
  faTrash,
  faEdit,
  faArrowsRotate,
} from "@fortawesome/free-solid-svg-icons";
import InputV2 from "../../../material/input/InputV2";
import Select from "../../../material/select/SelectV2";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../../../RedirectCode400";
import * as adminApi from "../../../../service/adminApi";
import { CurrentUserContext } from "../../../../App";

import { role_list } from "./service/Service";

export default function MenuManagement() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const [initialMenu, setInitialMenu] = useState([]);
  const [menu, setMenu] = useState([]);
  const [openSubmenu, setOpenSubmenu] = useState({});
  const [role, setRole] = useState("PUBLIC");
  const [select, setSelect] = useState("");
  const [nameMenu, setNameMenu] = useState("");
  const [weight, setWeight] = useState("");
  const [url, setUrl] = useState("");
  const navigate = useNavigate();

  const [typeOptions, setTypeOptions] = useState([]);
  let level = 1;

  useEffect(() => {
    getMenuList();
    getParent();
  }, [role]);

  const handleRoleChange = (newRoles) => {
    setRole(newRoles);
  };

  const getMenuList = async () => {
    let raw = { role: role };
    let res = await adminApi.getMenu(raw);
    if (res) {
      if (res["data"]["code"] === 200) {
        setInitialMenu(res["data"]["menu_list"]);
        setMenu(res["data"]["menu_list"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getParent = async () => {
    let raw = { parent: "parent", role: role };
    let res = await adminApi.getMenu(raw);
    if (res) {
      if (res["data"]["code"] === 200) {
        const formattedMenuList = Object.entries(res["data"]["menu_list"]).map(
          ([name, value]) => ({
            name,
            value,
          }),
        );
        setTypeOptions(formattedMenuList);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  // move up first level
  const moveMenuUp = (index) => {
    if (index > 0) {
      const newMenu = [...menu];
      [newMenu[index], newMenu[index - 1]] = [
        newMenu[index - 1],
        newMenu[index],
      ];
      [newMenu[index].weight, newMenu[index - 1].weight] = [
        newMenu[index - 1].weight,
        newMenu[index].weight,
      ];
      setMenu(newMenu);
    }
  };

  // move down first level
  const moveMenuDown = (index) => {
    if (index < menu.length - 1) {
      const newMenu = [...menu];
      [newMenu[index], newMenu[index + 1]] = [
        newMenu[index + 1],
        newMenu[index],
      ];
      [newMenu[index].weight, newMenu[index + 1].weight] = [
        newMenu[index + 1].weight,
        newMenu[index].weight,
      ];
      setMenu(newMenu);
    }
  };

  // move sub menu up
  const moveSubmenuUp = (menuIndex, submenuIndex, level) => {
    const newMenu = [...menu];

    if (level - 1 === 0) {
      const submenu = newMenu[menuIndex].submenu || [];
      if (submenu && submenuIndex > 0) {
        [submenu[submenuIndex], submenu[submenuIndex - 1]] = [
          submenu[submenuIndex - 1],
          submenu[submenuIndex],
        ];

        [submenu[submenuIndex].weight, submenu[submenuIndex - 1].weight] = [
          submenu[submenuIndex - 1].weight,
          submenu[submenuIndex].weight,
        ];

        setMenu(newMenu);
      }
    } else {
      const submenu = newMenu[menuIndex].submenu || [];

      if (submenu && submenu.length > 0) {
        const moveSubmenuRecursively = (submenus, currentLevel) => {
          if (currentLevel === level) {
            if (submenuIndex > 0 && submenuIndex < submenus.length) {
              const temp = submenus[submenuIndex];
              submenus[submenuIndex] = submenus[submenuIndex - 1];
              submenus[submenuIndex - 1] = temp;

              [
                submenus[submenuIndex].weight,
                submenus[submenuIndex - 1].weight,
              ] = [
                submenus[submenuIndex - 1].weight,
                submenus[submenuIndex].weight,
              ];
              // console.log(newMenu);
              setMenu(newMenu);
            }
          } else {
            submenus.forEach((submenuItem) => {
              if (submenuItem.submenu && submenuItem.submenu.length > 0) {
                moveSubmenuRecursively(submenuItem.submenu, currentLevel + 1);
              }
            });
          }
        };
        moveSubmenuRecursively(submenu, 1);
      }
    }
  };

  // move sub menu down
  const moveSubmenuDown = (menuIndex, submenuIndex, level) => {
    const newMenu = [...menu];

    if (level - 1 === 0) {
      const submenu = newMenu[menuIndex].submenu || [];
      if (submenu && submenuIndex < submenu.length - 1 && submenuIndex >= 0) {
        [submenu[submenuIndex], submenu[submenuIndex + 1]] = [
          submenu[submenuIndex + 1],
          submenu[submenuIndex],
        ];

        [submenu[submenuIndex].weight, submenu[submenuIndex + 1].weight] = [
          submenu[submenuIndex + 1].weight,
          submenu[submenuIndex].weight,
        ];

        setMenu(newMenu);
      }
    } else {
      const submenu = newMenu[menuIndex].submenu || [];

      if (submenu && submenu.length > 0) {
        const moveSubmenuRecursively = (submenus, currentLevel) => {
          if (currentLevel === level) {
            if (submenuIndex < submenus.length - 1 && submenuIndex >= 0) {
              const temp = submenus[submenuIndex];
              submenus[submenuIndex] = submenus[submenuIndex + 1];
              submenus[submenuIndex + 1] = temp;

              [
                submenus[submenuIndex].weight,
                submenus[submenuIndex + 1].weight,
              ] = [
                submenus[submenuIndex + 1].weight,
                submenus[submenuIndex].weight,
              ];

              setMenu(newMenu);
            }
          } else {
            submenus.forEach((submenuItem) => {
              if (submenuItem.submenu && submenuItem.submenu.length > 0) {
                moveSubmenuRecursively(submenuItem.submenu, currentLevel + 1);
              }
            });
          }
        };
        moveSubmenuRecursively(submenu, 1);
      }
    }
  };

  // move to inside ( first level to sub menu)
  const moveInside = (index) => {
    if (index === 0) return;

    const newMenu = [...menu];
    const menuItem = newMenu[index];
    const previousMenuItem = newMenu[index - 1];

    if (!previousMenuItem.submenu) {
      previousMenuItem.submenu = [];
    }

    menuItem.parent_id = previousMenuItem.menu_id;
    menuItem.weight = String(previousMenuItem.submenu.length + 1);

    previousMenuItem.submenu.push(menuItem);
    newMenu.splice(index, 1);
    setMenu(newMenu);
  };

  // move sub menu inside
  const moveSubmenuInside = (menuIndex, submenuIndex, level) => {
    if (submenuIndex === 0) return;
    const newMenu = [...menu];

    const moveSubmenuRecursively = (submenus, currentLevel) => {
      if (currentLevel === level) {
        if (submenuIndex > 0 && submenuIndex < submenus.length) {
          const currentSubmenuItem = submenus[submenuIndex];
          const previousSubmenuItem = submenus[submenuIndex - 1];

          if (!previousSubmenuItem.submenu) {
            previousSubmenuItem.submenu = [];
          }

          currentSubmenuItem.parent_id = previousSubmenuItem.menu_id;
          currentSubmenuItem.weight = String(
            previousSubmenuItem.submenu.length + 1,
          );

          previousSubmenuItem.submenu.push(currentSubmenuItem);
          submenus.splice(submenuIndex, 1);
        }
      } else {
        submenus.forEach((submenuItem) => {
          if (submenuItem.submenu && submenuItem.submenu.length > 0) {
            moveSubmenuRecursively(submenuItem.submenu, currentLevel + 1);
          }
        });
      }
    };

    moveSubmenuRecursively(newMenu[menuIndex].submenu, 1);
    setMenu(newMenu);
  };

  // move menu to out side
  const moveSubmenuOutside = (menuIndex, submenuIndex, level) => {
    const newMenu = [...menu];

    if (level - 1 === 0) {
      const submenu = newMenu[menuIndex]?.submenu || [];

      if (submenu && submenu[submenuIndex]) {
        const submenuItem = submenu[submenuIndex];
        submenu.splice(submenuIndex, 1);

        submenuItem.parent_id = "";
        submenuItem.submenu = submenuItem.submenu || [];
        submenuItem.weight = String(newMenu.length + 1);
        const newMenuItem = submenuItem;

        newMenu.push(newMenuItem);
        setMenu(newMenu);
      }
    } else {
      const moveSubmenuRecursively = (submenus, currentLevel) => {
        if (currentLevel === level) {
          const submenuItem = submenus[submenuIndex];

          submenus.splice(submenuIndex, 1);

          submenuItem.parent_id = newMenu[menuIndex].menu_id;
          submenuItem.weight = String(newMenu.length + 1);
          newMenu[menuIndex].submenu.push(submenuItem);
          setMenu(newMenu);
        } else {
          submenus.forEach((submenuItem) => {
            if (submenuItem.submenu && submenuItem.submenu.length > 0) {
              moveSubmenuRecursively(submenuItem.submenu, currentLevel + 1);
            }
          });
        }
      };
      moveSubmenuRecursively(newMenu[menuIndex].submenu, 1);
    }
  };

  const AddMenu = async () => {
    const input = {
      role: role || "",
      name: nameMenu,
      url: url,
      weight: weight,
      parent_id: select,
      external: false,
      active: true,
    };
    if (!input.url) {
      setIsMessage({ type: "warning", data: "เกิดกรอกลิงก์" });
    }
    let res = await adminApi.addMenu(input);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        getMenuList();
        setNameMenu("");
        setSelect("");
        setWeight("");
        setUrl("");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const submitMenuFlag = async () => {
    try {
      const res = await adminApi.addMenuFlag(menu);

      if (res) {
        const { code, message_th, message } = res.data;

        if (code === 200) {
          setIsMessage({ type: "success", data: message_th || message });
          getMenuList();
          setNameMenu("");
          setSelect("");
          setUrl("");
          setWeight("");
          getParent();
        } else if (code === 403) {
          navigate(RedirectCode400());
        } else {
          setIsMessage({ type: "warning", data: message_th || message });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    } catch (error) {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeMenu = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["name"]} ใช่หรือไม่`)) {
      return;
    }
    let res = await adminApi.removeMenu(item.menu_id);
    if (res) {
      if (res["data"]["code"] === 200) {
        getMenuList();
        getParent();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      getMenuList();
      getParent();
    }
  };

  const toggleSubmenu = (index) => {
    setOpenSubmenu((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const renderSubmenu = (submenu = [], menuIndex, level) => {
    if (!submenu || !submenu.length) return null;

    return (
      <div className="m-[17px_13px] rounded-[6px] border border-[#E0DFE2] p-[17px_13px] gap-[5px]">
        {submenu.map((submenuItem, submenuIndex) => {
          if (!submenuItem) return null;
          return (
            <div key={submenuItem.id} className="mb-[5px]">
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[5px] justify-center items-center">
                  {submenuItem?.submenu?.length > 0 ? (
                    <FontAwesomeIcon
                      icon={faPlus}
                      size="0.5"
                      className="h-[15px] w-[15px] p-[6px] bg-[#55CE63] cursor-pointer text-[#FFFFFF] rounded-[6px]"
                      onClick={() => toggleSubmenu(submenuIndex)}
                    />
                  ) : null}
                  <span>{submenuItem.name}</span>
                </div>
                <div className="flex justify-center items-center gap-[5px]">
                  {submenuIndex !== 0 && (
                    <FontAwesomeIcon
                      icon={faAngleUp}
                      onClick={() =>
                        moveSubmenuUp(menuIndex, submenuIndex, level)
                      }
                      size="0.5"
                      className="h-[15px] w-[15px] p-[6px] bg-[#6C757D] cursor-pointer text-[#FFFFFF]"
                    />
                  )}
                  {submenuIndex !== submenu.length - 1 && (
                    <FontAwesomeIcon
                      icon={faAngleDown}
                      onClick={() =>
                        moveSubmenuDown(menuIndex, submenuIndex, level)
                      }
                      size="0.5"
                      className="h-[15px] w-[15px] p-[6px] bg-[#6C757D] cursor-pointer text-[#FFFFFF]"
                    />
                  )}
                  <FontAwesomeIcon
                    icon={faTurnDown}
                    onClick={() =>
                      moveSubmenuOutside(menuIndex, submenuIndex, level)
                    }
                    size="0.5"
                    className="h-[15px] w-[15px] p-[6px] bg-[#6C757D] cursor-pointer text-[#FFFFFF]"
                  />
                  {submenuIndex !== 0 && (
                    <FontAwesomeIcon
                      icon={faTurnUp}
                      onClick={() =>
                        moveSubmenuInside(menuIndex, submenuIndex, level)
                      }
                      size="0.5"
                      className="h-[15px] w-[15px] p-[6px] bg-[#6C757D] cursor-pointer text-[#FFFFFF]"
                    />
                  )}
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => removeMenu(submenuItem)}
                    size="0.5"
                    className="h-[15px] w-[15px] p-[6px] bg-[#FCD8DB] cursor-pointer text-[#D32736]"
                  />
                </div>
              </div>
              {openSubmenu[submenuIndex] &&
                submenuItem?.submenu?.length > 0 &&
                renderSubmenu(submenuItem.submenu, menuIndex, level + 1)}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="flex flex-row items-center justify-start gap-[10px] mb-[10px]">
        <button
          onClick={() =>
            navigate("/admin/management/menu/add-menu", {
              state: { type: "menu" },
            })
          }
          className="rounded-[6px] bg-[#55CE63] p-[7px_9px] text-[#FFFFFF] flex flex-row justify-center items-center cursor-pointer gap-[5px]"
          aria-label="Add New Menu"
        >
          <FontAwesomeIcon icon={faPlus} size="1x" /> เพิ่มเมนูใหม่
        </button>
        <button
          onClick={() =>
            navigate("/admin/management/menu/menu-list", {
              state: { type: "menu" },
            })
          }
          className="rounded-[6px] bg-[#00C6FC] p-[7px_9px] text-[#FFFFFF] flex flex-row justify-center items-center cursor-pointer gap-[5px]"
        >
          <FontAwesomeIcon icon={faEdit} size="1x" /> แก้ไขรายการข้อมูลทั้งหมด
        </button>
      </div>
      <div className="flex flex-row items-center justify-start gap-[10px] mb-[10px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          <div className="">
            <Select
              value={role}
              list={role_list}
              setValue={handleRoleChange}
              placeholder="เลือกสถานะ"
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center items-start gap-[10px] w-full md:flex-col">
        <div className="rounded-[6px] border border-[#E0DFE2] w-[50%] md:w-full">
          <div className="p-[17px_13px] border-b border-[#E0DFE2]">
            รายการเมนู
          </div>
          <div className="p-[17px_13px]">
            <div className="w-full flex flex-col justify-start">
              <div className="rounded-[6px] border border-[#E0DFE2]">
                {menu.length > 0 ? (
                  menu.map((item, index) => (
                    <div key={item.id}>
                      <div
                        className={`flex justify-between items-center p-[15px_18px] ${
                          index === menu.length - 1
                            ? "border-t border-[#E0DFE2]"
                            : "border-b border-[#E0DFE2]"
                        }`}
                      >
                        <div className="flex flex-row gap-[5px] justify-center items-center">
                          {item.submenu.length > 0 ? (
                            <FontAwesomeIcon
                              icon={faPlus}
                              size="0.5"
                              className="h-[15px] w-[15px] p-[6px] bg-[#55CE63] cursor-pointer text-[#FFFFFF] rounded-[6px]"
                              onClick={() => toggleSubmenu(index)}
                            />
                          ) : null}
                          <span>{item.name}</span>
                        </div>
                        <div className="flex justify-center items-center gap-[5px]">
                          {index !== 0 && (
                            <FontAwesomeIcon
                              icon={faAngleUp}
                              onClick={() => moveMenuUp(index)}
                              size="0.5"
                              className="h-[15px] w-[15px] p-[6px] bg-[#6C757D] cursor-pointer text-[#FFFFFF]"
                            />
                          )}
                          {index !== menu.length - 1 && (
                            <FontAwesomeIcon
                              icon={faAngleDown}
                              onClick={() => moveMenuDown(index)}
                              size="0.5"
                              className="h-[15px] w-[15px] p-[6px] bg-[#6C757D] cursor-pointer text-[#FFFFFF]"
                            />
                          )}
                          {index !== 0 && (
                            <FontAwesomeIcon
                              icon={faTurnUp}
                              onClick={() => moveInside(index)}
                              size="0.5"
                              className="h-[15px] w-[15px] p-[6px] bg-[#6C757D] cursor-pointer text-[#FFFFFF]"
                            />
                          )}
                          <FontAwesomeIcon
                            icon={faTrash}
                            onClick={() => removeMenu(item)}
                            size="0.5"
                            className="h-[15px] w-[15px] p-[6px] bg-[#FCD8DB] cursor-pointer text-[#D32736]"
                          />
                        </div>
                      </div>
                      {openSubmenu[index] &&
                        item.submenu.length > 0 &&
                        renderSubmenu(item.submenu, index, level)}
                    </div>
                  ))
                ) : (
                  <div
                    className={`flex justify-between items-center p-[15px_18px]`}
                  >
                    ไม่มีข้อมูล
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-[6px] border border-[#E0DFE2] w-[50%] md:w-full">
          <div className="p-[17px_13px] border-b border-[#E0DFE2] bg-[#93D3B1]">
            เมนูทั้งหมด
          </div>
          <div className="p-[17px_13px]">
            <div className="w-full mb-[10px]">
              เลือกเมนู
              <Select
                value={select}
                setValue={(value) => setSelect(value)}
                list={typeOptions}
                placeholder="เลือกเมนู"
              />
            </div>
            <div className="w-full mb-[10px]">
              ลำดับ
              <InputV2
                value={weight}
                placeholder=""
                onChangeEvt={(value) => setWeight(value)}
              />
            </div>
            <div className="w-full mb-[10px]">
              ชื่อเมนู
              <InputV2
                value={nameMenu}
                placeholder=""
                onChangeEvt={(value) => setNameMenu(value)}
              />
            </div>
            <div className="w-full mb-[10px]">
              URL
              <InputV2
                value={url}
                placeholder=""
                onChangeEvt={(value) => setUrl(value)}
              />
            </div>
          </div>
          <div className="p-[17px_13px] border-t border-[#E0DFE2]">
            <button
              className="rounded-[6px] p-[6px_9px] flex justify-center items-center bg-[#00C5FB] text-[16px] text-[#FFFFFF]"
              onClick={() => AddMenu()}
            >
              <FontAwesomeIcon
                icon={faPlus}
                size="1"
                className="h-[10px] w-[10px] p-[6px] cursor-pointer text-[#FFFFFF]"
              />
              เพิ่มเมนูไปยัง Menu List
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-row items-center justify-start gap-[10px] mb-[10px] mt-[10px]">
        <button
          onClick={() => submitMenuFlag()}
          className="rounded-[6px] bg-[#55CE63] p-[7px_9px] text-[#FFFFFF] flex flex-row justify-center items-center cursor-pointer gap-[5px]"
          aria-label="Add New Menu"
        >
          บันทึก
        </button>
        <button
          onClick={() => {
            // setMenu([]);

            // setMenu(initialMenu);
            getMenuList(role);
          }}
          className="rounded-[6px] bg-[#C0C0C0] p-[7px_9px] text-[#FFFFFF] flex flex-row justify-center items-center cursor-pointer gap-[5px]"
        >
          <FontAwesomeIcon icon={faArrowsRotate} size="1" /> คืนค่า
        </button>
      </div>
    </>
  );
}
